// test2527
(2527 && 0);
